<template>
    <b-card class="formations shareholders">
        <b-card
            title="Shareholders"
            class="mt-2 bordered-card shareholders-section"
        >
            <shareholder-index
                v-if="! showCreateOrEditShareholderForm && ! showCreateOrEditNomineeShareholderForm"
                :shareholders-list="{
                    shareholders,
                    shareholdersDropdownList
                }"
                :is-shareholder-full="isShareholderFull"
                :shareholder-blue-print="shareholderBluePrint"
                :is-fetching-data="isFetchingData"
                :has-nominee-director="hasNomineeDirector"
                :generate-poa="requiredPOA"
                @createShareholder="openCreateOrEditShareholderForm"
                @edit="openCreateOrEditShareholderForm"
                @remove="removeShareholder"
                @openCreateShareholderForm="openCreateOrEditShareholderForm"
                @createShareholderFromDropdown="createShareholderFromDropdown"
            />

            <div class="mt-2 position-relative">
                <transition name="fade-bottom" mode="out-in">
                    <create-or-edit-shareholder-form
                        v-if="showCreateOrEditShareholderForm"
                        ref="createOrEdit"
                        :data-status="shareholderStatus"
                        :data-shareholder="shareholderBluePrint"
                        :data-directors="directors"
                        :all-shareholders="shareholders"
                        :total-number-of-share="totalNumberOfShare"
                        :company-total-share="meta.total_number_of_shares"
                        :has-nominee-director="hasNomineeDirector"
                        :generate-poa="requiredPOA"
                        @cancel="showCreateOrEditShareholderForm = false"
                        @createOrEdit="storeOrUpdateShareholder"
                    />
                </transition>
            </div>

            <div class="total-share-percentage">
                <p>
                    Shareholding Percentage:
                    <strong>{{ totalSharePercentage }} %</strong>
                </p>

                <b-progress
                    :value="totalSharePercentage"
                    max="100"
                    variant="success"
                    style="height: 6px"
                ></b-progress>

                <small
                    v-if="! isShareholderFull"
                    style="font-style: italic"
                    class="pt-.5 d-block text-danger"
                >
                    Shareholders' share percentages should all add up to 100%.
                </small>
            </div>
        </b-card>

        <div class="d-flex justify-content-between mt-3">
            <b-button variant="outline-primary" @click="$emit('previous')">
                <!-- <img :src="'/icons/left-arrow.svg'" alt="left-arrow" /> -->
                <vector data-type="icons" data-width="16px" data-height="13px" data-name="left-arrow" />
                Previous
            </b-button>

            <b-button
variant="primary" data-test="next"
                :disabled="loading || isFetchingData"
                class=" d-flex justify-content-center next-button align-items-center"
                @click="next"
            >
                Next
                <normal-loader v-if="loading" class="ml-.5" />
                <img v-else :src="'/icons/right-arrow.svg'" class="ml-.5" alt="right-arrow" />
            </b-button>
        </div>
    </b-card>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { BCard, BButton, BProgress } from "bootstrap-vue";
import Formation from "@/models/Formation";
import { errorToast } from "@/views/helpers/toast";
import {
    SHAREHOLDER_FILL_OUT_ALL_FIELD_ERROR,
    SOMETHING_WENT_WRONG,
    TOTAL_SHARE_PERCENTAGE_ERROR,
} from "@/constants/errors";
import { 
    SHAREHOLDER,
    DIRECTORS_AND_SHAREHOLDERS,
    SECRETARIES,
    NOMINEE_SHAREHOLDER,
} from "@/constants/config";
import { formatDate } from '@/helpers';
import { userInfoLocalize } from '@/localize/userInfoLocalizer';
import ShareholderIndex from "./directors_and_shareholders/ShareholderIndex.vue";
import CreateOrEditShareholderForm from "./directors_and_shareholders/ShareholderCreateOrEdit.vue";

export default {
    components: {
        BCard,
        BButton,
        BProgress,
        ShareholderIndex,
        CreateOrEditShareholderForm,
    },

    data() {
        return {
            shareholderBluePrint: {
                _id: undefined,
                referenceId: undefined,
                shareholderType: undefined,
                name: undefined,
                idType: undefined,
                dateOfExpiry: undefined,
                nric: undefined,
                nationality: undefined,
                country: undefined,
                dob: undefined,
                email: undefined,
                contactNumber: undefined,
                noOfShares: undefined,
                sharePercentage: undefined,
                shareTypeId: 1,
                generateDueDiligence: false,
                sourcesOfFunds: undefined,
                otherSource: undefined,
                sourceOfWealth: undefined,
                otherWealth: undefined,
                address: undefined,
                primaryCorporateRepresentativeName: undefined,
                primaryCorporateRepresentativeAddress: undefined,
                secondaryCorporateRepresentativeName: undefined,
                secondaryCorporateRepresentativeAddress: undefined,
                POAAuthorizePersonOneName: undefined,
                POAAuthorizePersonOneEmail: undefined,
                hasSecondPOA: false,
                POAAuthorizePersonTwoName: undefined,
                POAAuthorizePersonTwoEmail: undefined,
                POAAuthorizedPersonType: undefined,

                // nominee shareholder
                isNomineeShareholder: undefined,
                isNewNominator: undefined,
                appointmentDate: undefined,
                cessationDate: undefined,
                nominatorType:undefined,
                nominatorName: undefined,
                nominatorAlias: undefined,
                // new nominator field
                newNominatorName: undefined,
                nominatorNRIC: undefined,
                nominatorIdType: undefined,
                nominatorDateOfExpiry: undefined,
                nominatorNationality: undefined,
                nominatorDOB: undefined,
                nominatorAddress: undefined,
                nominatorEmail: undefined,
                // end new nominator field
                nominatorUen: undefined,
                nominatorStatue: undefined,
                nominatorLegalForm: undefined,
                nominatorJurisdiction: undefined,
                nominatorRegistrar: undefined,
                remark: undefined,
            },

            shareholders: [],
            directors: [],
            shareholdersDropdownList: [],
            shareholderKeys: [],
            shareholderTotalSteps: 0,
            shareholderStatus: undefined,
            showCreateOrEditShareholderForm: false,

            nomineeShareholderBluePrint: {
                _id: undefined,
                id: undefined,
                shareholderNominatorId: undefined,
                shareholder: undefined,
                appointmentDate: undefined,
                cessationDate: undefined,
                remark: undefined,
                nominator: undefined,
                alias: undefined,
                nominatorType: undefined,
                uen: undefined,
                statue: undefined,
                registrar: undefined,
                jurisdiction: undefined,
                legalForm: undefined,
            },

            nomineeShareholders: [],
            nomineeShareholderStatus: undefined,
            showCreateOrEditNomineeShareholderForm: false,

            hasNomineeDirector: false,
            requiredPOA: false,
            meta: {},
            isFetchingData: true,
            loading: false,
        };
    },

    computed: {
        totalSharePercentage()
        {
            if (this.shareholders.length >= 1)
            {
                let percentage = this.shareholders.map(shareholder => parseFloat(shareholder.sharePercentage)).reduce((previous, next) => previous + next);
                
                if (percentage % 10 !== 0)
                    percentage = percentage.toFixed(2);

                return percentage;
            }
            return 0;
        },

        totalNumberOfShare()
        {
            if (this.shareholders.length >= 1)
                return this.shareholders.map(shareholder => parseInt(shareholder.noOfShares, 10)).reduce((previous, next) => previous + next);

            return 0;
        },

        isShareholderFull()
        {
            return this.totalSharePercentage >= 100;
        },
    },

    async created() {
        this.isFetchingData = true;
        this.shareholderKeys = Object.keys(this.shareholderBluePrint);

        const data = await Formation.getShareholders();
        
        data.directors.forEach(director => {
            this.directors.push({
                userId: director.user_id,
                name: director.user.user_info?.legal_name ?? director.user.name,
                email: director.user.email,
                nric: director.user.user_info?.NRIC
            });
        });
        
        data.shareholders.forEach(shareholder => {
            const isShareholderIsNominee = this.isShareholderIsNominee(shareholder, data.nominee_shareholders);
            
            const shareholderData  = {
                _id: this.generateUniqueId(),
                referenceId: shareholder.reference_id,
                shareholderType: {
                    text: shareholder.shareholder_type,
                    value: shareholder.shareholder_type
                },
                name: shareholder.user.user_info?.legal_name ?? shareholder.user.name,
                idType: shareholder.user.user_info?.id_type
                    ? {
                        id: shareholder.user.user_info.id_type?.id,
                        name: shareholder.user.user_info.id_type?.name,
                    }
                    : undefined,
                nric: shareholder.user.user_info
                    ? shareholder.user.user_info.NRIC
                    : undefined,
                nationality: shareholder.shareholder_type === SHAREHOLDER.TYPE.INDIVIDUAL && shareholder.user.user_info?.nationality
                    ? { 
                        value: shareholder.user.user_info.nationality?.id,
                        text: shareholder.user.user_info.nationality?.name
                    }
                    : undefined,
                dateOfExpiry: formatDate(shareholder.user.user_info?.date_of_expiry),
                country: shareholder.shareholder_type === SHAREHOLDER.TYPE.CORPORATE && shareholder.user.user_info?.country
                    ? { 
                        text: shareholder.user.user_info.country?.name, 
                        value: shareholder.user.user_info.country?.id, 
                    }
                    : undefined,
                dob: shareholder.user.user_info
                    ? formatDate(shareholder.user.user_info.DOB)
                    : undefined,
                email: shareholder.user.email,
                contactNumber: shareholder.user.user_info
                    ? shareholder.user.user_info.contact_number
                    : undefined,
                noOfShares: shareholder.number_of_shares
                    ? shareholder.number_of_shares
                    : 0,
                sharePercentage: shareholder?.share_percentage,
                shareTypeId: shareholder.company.share_capital.share_type_id,
                generateDueDiligence: shareholder.source_of_funds?.length > 0 && shareholder.source_of_wealths?.length > 0,
                sourcesOfFunds: this.localizeSourceOfFundsAndSourceOfWealths(shareholder, 'sof'),
                otherSource: shareholder?.other_reasons?.description,
                sourceOfWealth: this.localizeSourceOfFundsAndSourceOfWealths(shareholder, 'sow'),
                otherWealth: shareholder.other_wealths?.description,
                address: shareholder.user.user_info
                    ? shareholder.user.user_info.address
                    : undefined,
                POAAuthorizePersonOneName: shareholder.corporate_directors.length >= 1
                    ? shareholder.corporate_directors[0].user.name
                    : undefined,
                POAAuthorizePersonOneEmail: shareholder.corporate_directors.length >= 1
                    ? shareholder.corporate_directors[0].user.email
                    : undefined,
                
                hasSecondPOA: shareholder.corporate_directors.length >= 2,
                POAAuthorizePersonTwoName: shareholder.corporate_directors.length >= 1
                    ? shareholder.corporate_directors[1]?.user.name
                    : undefined,
                POAAuthorizePersonTwoEmail: shareholder.corporate_directors.length >= 1
                    ? shareholder.corporate_directors[1]?.user.email
                    : undefined,
                POAAuthorizedPersonType: shareholder.corporate_directors.length >= 1
                    ? this.getSecondaryAuthorizedPersonType(shareholder.corporate_directors[1]?.is_secretary)
                    : undefined,
                primaryCorporateRepresentativeName: shareholder
                    .corporate_representatives[0]
                    ? shareholder.corporate_representatives[0].name
                    : undefined,
                primaryCorporateRepresentativeAddress: shareholder
                    .corporate_representatives[0]
                    ? shareholder.corporate_representatives[0].address
                    : undefined,
                secondaryCorporateRepresentativeName: shareholder
                    .corporate_representatives[1]
                    ? shareholder.corporate_representatives[1].name
                    : undefined,
                secondaryCorporateRepresentativeAddress: shareholder
                    .corporate_representatives[1]
                    ? shareholder.corporate_representatives[1].address
                    : undefined,
                
                // nominee shareholder
                isNomineeShareholder: isShareholderIsNominee,
            };

            if(isShareholderIsNominee) {
                const nominator = this.getNomineeShareholderNominator(shareholder, data.nominee_shareholders);

                this.shareholders.push({ ...shareholderData , ...{
                    isNewNominator: this.isShareholderNominatorIsNew(data.shareholders, nominator.shareholder_nominator.shareholder.user.email),
                    appointmentDate: formatDate(nominator.appointment_date),
                    cessationDate: formatDate(nominator.cessation_date),
                    nominatorType: nominator.shareholder_nominator.shareholder_type ? this.getShareholderType(nominator.shareholder_nominator.shareholder_type) : null,
                    nominatorName: nominator.shareholder_nominator?.shareholder.user ? 
                        {
                            _idForShareholder: this.shareholders.find(holder => holder.referenceId === nominator.shareholder_nominator?.shareholder?.user?.id)?._id,
                            text: nominator.shareholder_nominator.shareholder.user.user_info.legal_name,
                            value: nominator.shareholder_nominator.shareholder.user.id,
                            email: nominator.shareholder_nominator.shareholder.user.email,
                            uen: nominator.shareholder_nominator.shareholder.uen,
                            nric: nominator.shareholder_nominator.shareholder.user.user_info?.NRIC
                        } : undefined,
                    nominatorAlias: nominator.shareholder_nominator?.shareholder?.alias,
                    // new nominator field
                    newNominatorName: nominator.shareholder_nominator?.shareholder?.user?.user_info.legal_name,
                    nominatorNRIC: nominator.shareholder_nominator?.shareholder.user?.user_info?.NRIC,
                    nominatorIdType: nominator.shareholder_nominator?.shareholder?.user?.user_info?.id_type ? 
                        {
                            id: nominator.shareholder_nominator.shareholder.user.user_info.id_type.id,
                            name: nominator.shareholder_nominator.shareholder.user.user_info.id_type.name
                        }: undefined,
                    nominatorDateOfExpiry: nominator.shareholder_nominator?.shareholder?.user?.user_info?.date_of_expiry,
                    nominatorNationality: nominator.shareholder_nominator?.shareholder?.user?.user_info?.nationality ? 
                        {
                            value: nominator.shareholder_nominator.shareholder.user.user_info.nationality.id,
                            text: nominator.shareholder_nominator.shareholder.user.user_info.nationality.name
                        }: null,
                    nominatorDOB: formatDate(nominator.shareholder_nominator?.shareholder?.user?.user_info?.DOB),
                    nominatorAddress: nominator.shareholder_nominator?.shareholder?.user?.user_info?.address,
                    nominatorEmail: nominator.shareholder_nominator?.shareholder?.user?.email,
                    // end new nominator field
                    nominatorUen: nominator.shareholder_nominator?.shareholder?.uen,
                    nominatorStatue: nominator.shareholder_nominator?.shareholder?.statue,
                    nominatorLegalForm: nominator.shareholder_nominator?.shareholder?.legal_form,
                    nominatorJurisdiction: nominator.shareholder_nominator?.shareholder?.jurisdiction,
                    nominatorRegistrar: nominator.shareholder_nominator?.shareholder?.registrar,
                    remark: nominator.remark,
                }});
            }
            else this.shareholders.push(shareholderData);
        });

        // the list from the dropdown
        data.users.forEach(user => {
            // shareholder.name === user.name &&
            if (
                !this.shareholders.find(
                    shareholder => shareholder.email === user.email
                )
            ) {
                this.shareholdersDropdownList.push(userInfoLocalize(user));
            }
        });

        this.meta = data.meta;
        this.hasNomineeDirector = data.meta.has_nominee_directors;
        this.requiredPOA = data.meta.is_require_poa;
        // eslint-disable-next-line no-unneeded-ternary
        this.isFetchingData = false;
    },

    methods: {
        localizeSourceOfFundsAndSourceOfWealths(shareholder, type = 'sof') {
            if(type === 'sof')
                return shareholder.source_of_funds.map(sof => sof.id);
            return shareholder.source_of_wealths.map(sow => sow.id);
        },

        getSecondaryAuthorizedPersonType(isSecretary) {
            if(isSecretary) 
                return SECRETARIES.SECRETARY_NAME;
            return DIRECTORS_AND_SHAREHOLDERS.DIRECTOR_NAME;
        },

        // shareholders
        isShareholderIsNominee(shareholder, nomineeShareholders) {
            return nomineeShareholders.filter(nomineeShareholder => shareholder.user.email.toLowerCase() === nomineeShareholder.company_shareholder.user.email.toLowerCase()).length > 0;
        },

        isShareholderNominatorIsNew(shareholders, nominatorEmail) {
            return shareholders.filter(shareholder => shareholder.user.email.toLowerCase() === nominatorEmail.toLowerCase()).length < 1;
        },  

        getNomineeShareholderNominator(shareholder, nomineeShareholders) {
            return nomineeShareholders.find(
                nomineeShareholder => shareholder.user.email.toLowerCase() === nomineeShareholder.company_shareholder.user.email.toLowerCase()
            );
        },

        createShareholderFromDropdown(shareholder) {
            if(! shareholder.shareholderType?.text) {
                // eslint-disable-next-line no-param-reassign
                shareholder.shareholderType = {
                    text: SHAREHOLDER.TYPE.INDIVIDUAL,
                    value: SHAREHOLDER.TYPE.INDIVIDUAL
                };

                // eslint-disable-next-line no-param-reassign
                shareholder.idType = undefined;
                
                // eslint-disable-next-line no-param-reassign
                shareholder.nationality = undefined;
            }
            this.openCreateOrEditShareholderForm(shareholder);
        },

        openCreateOrEditShareholderForm(
            shareholder = this.shareholderBluePrint,
            status = "create"
        ) {
            // reset Blue Print data
            Object.keys(this.shareholderBluePrint).forEach(key => {
                if (key !== "shareTypeId") this.shareholderBluePrint[key] = shareholder[key] ?? null;
            });

            this.showCreateOrEditShareholderForm = true;
            this.shareholderStatus = status;
        },

        storeOrUpdateShareholder(shareholder) {
            if (this.shareholderStatus === "edit") {
                this.shareholders.forEach(existingShareholder => {
                    if (existingShareholder._id === shareholder._id) {
                        Object.keys(this.shareholderBluePrint).forEach(
                            key => {
                                // eslint-disable-next-line no-param-reassign
                                existingShareholder[key] = shareholder[key];
                            }
                        );
                    }
                });
            }

            if (this.shareholderStatus === "create") {
                // eslint-disable-next-line no-param-reassign
                shareholder._id = this.generateUniqueId();
                this.shareholders.push(shareholder);
            }

            this.shareholdersDropdownList =
                this.shareholdersDropdownList.filter(
                    existingShareholder =>
                        existingShareholder.name !== shareholder.name &&
                        existingShareholder.email && shareholder.email
                );

            this.showCreateOrEditShareholderForm = false;

            if(shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE && this.requiredPOA) {
                this.reinitializeRequirePOACount();
            }
        },

        removeShareholder(shareholder) {
            this.shareholders = this.shareholders.filter(
                existingShareholder => existingShareholder._id !== shareholder._id
            );
            this.shareholdersDropdownList.push(shareholder);

            // if current shareholder is nominee shareholder or 
            // nominee shareholder nominator then remove nominee shareholder list
            this.nomineeShareholders.forEach(nomineeShareholder => {
                if(
                    nomineeShareholder.shareholder.email.toLowerCase() === shareholder.email.toLowerCase() ||
                    nomineeShareholder.nominator.email.toLowerCase() === shareholder.email.toLowerCase()
                )
                    this.removeNomineeShareholder(nomineeShareholder);
            });

            if(shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE && this.requiredPOA) {
                this.reinitializeRequirePOACount();
            }
        },

        getShareholderType (type) {
            if(type.toLowerCase().includes(NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.INDIVIDUAL))
                return { 
                    text: NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.INDIVIDUAL,
                    value: NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.INDIVIDUAL
                };
            
            return { 
                text: NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.CORPORATE,
                value: NOMINEE_SHAREHOLDER.NOMINATOR.TYPE.CORPORATE
            };
        },

        notFromShareholderList(nominatorEmail) {
            return this.shareholders.filter(shareholder => nominatorEmail === shareholder.email).length < 1;
        },

        reinitializeRequirePOACount() {
            let count = 0;

            this.shareholders.forEach(shareholder => {
                if(shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE) {
                    if(
                        ! shareholder.POAAuthorizePersonOneName ||
                        ! shareholder.POAAuthorizePersonOneEmail 
                    ) {
                        count += 1 ;
                    }
                };
            });
           
            this.$store.commit('shareholder/UPDATE_POA_REQUIRE_COUNT', count);
        },

        generateUniqueId() {
            return Math.round(Math.random() * 1000);
        },

        next() {
            this.loading = true;
            if (! this.validate(this.shareholders)) {
                errorToast(SHAREHOLDER_FILL_OUT_ALL_FIELD_ERROR);
                this.loading = false;
                return;
            }

            // throws error if total share percentage is not 100
            if ( parseInt(this.totalSharePercentage, 10) !== 100 ) {
                errorToast(TOTAL_SHARE_PERCENTAGE_ERROR);
                this.loading = false;
                return;
            }

            Formation.updateShareholders({
                shareholders: this.shareholders,
            })
                .then(() => {
                    this.$emit("next");
                    this.loading = false;
                })
                .catch(e => {
                    errorToast(SOMETHING_WENT_WRONG);
                    console.error(
                        "error while trying to store shareholders in formation",
                        e
                    );
                    this.loading = false;
                });
        },

        validate(shareholders) {
            // eslint-disable-next-line array-callback-return
            const validShareholderCount = shareholders.filter(shareholder =>
                Object.keys(shareholder).filter(key => {
                    if (shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE) {
                        if (! this.hasNomineeDirector && ! this.requiredPOA) {
                            if(shareholder.isNomineeShareholder) {
                                // INDIVIDUAL NOMINATOR 
                                if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                                    if(shareholder.isNewNominator)
                                        return (
                                            !!shareholder[key] &&
                                            !key.includes("secondaryCorporateRepresentative") &&
                                            !key.includes("POA") &&
                                            !key.includes( "idType") &&
                                            !key.includes("dateOfExpiry") &&
                                            
                                            // sow and sof field
                                            !key.includes("generateDueDiligence") &&
                                            !key.includes("sourcesOfFunds") &&
                                            !key.includes("otherSource") &&
                                            !key.includes("sourceOfWealth") &&
                                            !key.includes("otherWealth") &&

                                            !key.includes("referenceId") &&
                                            key !== "address" &&
                                            // exclude 12 nominee shareholder fields
                                            !key.includes('isNomineeShareholder') &&
                                            !key.includes("nominatorDateOfExpiry") &&
                                            !key.includes('isNewNominator') &&
                                            !key.includes('cessationDate') &&
                                            !key.includes('nominatorUen') &&
                                            !key.includes('nominatorLegalForm') &&
                                            !key.includes('nominatorStatue') &&
                                            !key.includes('nominatorRegistrar') &&
                                            !key.includes('nominatorJurisdiction') &&
                                            !key.includes('nominatorAlias') &&
                                            !key.includes('remark') &&
                                            // ignore new nominator field
                                            !key.includes('nominatorEmail') &&
                                            !key.includes('nominatorName')
                                        );

                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("POA") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude 17 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorNRIC') &&
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorAddress') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('newNominatorName') &&
                                        ! key.includes('nominatorEmail')
                                    );
                                }

                                // CORPORATE NOMINATOR
                                if(shareholder.isNewNominator) 
                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("POA") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude 10 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorName') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorEmail')
                                    );
                                return (
                                    !!shareholder[key] &&
                                    !key.includes("secondaryCorporateRepresentative") &&
                                    !key.includes("POA") &&
                                    !key.includes( "idType") &&
                                    !key.includes("dateOfExpiry") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    !key.includes("referenceId") &&
                                    key !== "address" &&
                                    // exclude 12 nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes("nominatorDateOfExpiry") &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail')
                                );
                            }
                            return (
                                !!shareholder[key] &&
                                !key.includes("secondaryCorporateRepresentative") &&
                                !key.includes("POA") &&
                                !key.includes( "idType") &&
                                !key.includes("dateOfExpiry") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("referenceId") &&
                                key !== "address" &&
                                // exclude corporate nominator fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes("nominatorDateOfExpiry") &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail')
                            );
                        }

                        // SHAREHOLDER TYPE INDIVIDUAL, NOMINEE SHAREHOLDER AND HAS NOMINEE DIRECTOR
                        if(shareholder.isNomineeShareholder) {
                            // INDIVIDUAL NOMINATOR 
                            if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                                // has poa
                                if(this.requiredPOA) {
                                    if(shareholder.isNewNominator)
                                        return (
                                            !!shareholder[key] &&
                                            !key.includes("secondaryCorporateRepresentative") &&
                                            !key.includes( "idType") &&
                                            !key.includes("dateOfExpiry") &&
                                            
                                            // sow and sof field
                                            !key.includes("generateDueDiligence") &&
                                            !key.includes("sourcesOfFunds") &&
                                            !key.includes("otherSource") &&
                                            !key.includes("sourceOfWealth") &&
                                            !key.includes("otherWealth") &&

                                            !key.includes("referenceId") &&
                                            key !== "address" &&
                                            // exclude 12 nominee shareholder fields
                                            !key.includes('isNomineeShareholder') &&
                                            !key.includes("nominatorDateOfExpiry") &&
                                            !key.includes('isNewNominator') &&
                                            !key.includes('cessationDate') &&
                                            !key.includes('nominatorUen') &&
                                            !key.includes('nominatorLegalForm') &&
                                            !key.includes('nominatorStatue') &&
                                            !key.includes('nominatorRegistrar') &&
                                            !key.includes('nominatorJurisdiction') &&
                                            !key.includes('nominatorAlias') &&
                                            !key.includes('remark') &&
                                            // ignore new nominator field
                                            !key.includes('nominatorEmail') &&
                                            !key.includes('nominatorName') &&
                                            // ignore second poa field
                                            !key.includes('POAAuthorizePersonTwoName') &&
                                            !key.includes('POAAuthorizePersonTwoEmail') &&
                                            !key.includes('POAAuthorizedPersonType') &&
                                            !key.includes('hasSecondPOA')
                                        );

                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude 17 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorNRIC') &&
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorAddress') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('newNominatorName') &&
                                        ! key.includes('nominatorEmail') &&
                                        // ignore second poa field
                                        !key.includes('POAAuthorizePersonTwoName') &&
                                        !key.includes('POAAuthorizePersonTwoEmail') &&
                                        !key.includes('POAAuthorizedPersonType') &&
                                        !key.includes('hasSecondPOA')
                                    );
                                }

                                // has not poa
                                if(! this.requiredPOA) {
                                    if(shareholder.isNewNominator)
                                        return (
                                            !!shareholder[key] &&
                                            !key.includes("secondaryCorporateRepresentative") &&
                                            !key.includes( "idType") &&
                                            !key.includes("dateOfExpiry") &&

                                            // sow and sof field
                                            !key.includes("generateDueDiligence") &&
                                            !key.includes("sourcesOfFunds") &&
                                            !key.includes("otherSource") &&
                                            !key.includes("sourceOfWealth") &&
                                            !key.includes("otherWealth") &&

                                            !key.includes("referenceId") &&
                                            key !== "address" &&
                                            !key.includes("POA") &&
                                            // exclude 12 nominee shareholder fields
                                            !key.includes('isNomineeShareholder') &&
                                            !key.includes("nominatorDateOfExpiry") &&
                                            !key.includes('isNewNominator') &&
                                            !key.includes('cessationDate') &&
                                            !key.includes('nominatorUen') &&
                                            !key.includes('nominatorLegalForm') &&
                                            !key.includes('nominatorStatue') &&
                                            !key.includes('nominatorRegistrar') &&
                                            !key.includes('nominatorJurisdiction') &&
                                            !key.includes('nominatorAlias') &&
                                            !key.includes('remark') &&
                                            // ignore new nominator field
                                            !key.includes('nominatorEmail') &&
                                            !key.includes('nominatorName')
                                        );

                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        !key.includes("POA") &&
                                        // exclude 17 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorUen') &&
                                        !key.includes('nominatorLegalForm') &&
                                        !key.includes('nominatorStatue') &&
                                        !key.includes('nominatorRegistrar') &&
                                        !key.includes('nominatorJurisdiction') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorNRIC') &&
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorAddress') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('newNominatorName') &&
                                        ! key.includes('nominatorEmail')
                                    );
                                }
                            }

                            // CORPORATE NOMINATOR and has POA
                            if(this.requiredPOA) {
                                if(shareholder.isNewNominator) 
                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        // exclude 10 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorName') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorEmail') &&
                                        // ignore second poa field
                                        !key.includes('POAAuthorizePersonTwoName') &&
                                        !key.includes('POAAuthorizePersonTwoEmail') &&
                                        !key.includes('POAAuthorizedPersonType') &&
                                        !key.includes('hasSecondPOA')
                                    );
                                return (
                                    !!shareholder[key] &&
                                    !key.includes("secondaryCorporateRepresentative") &&
                                    !key.includes( "idType") &&
                                    !key.includes("dateOfExpiry") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    !key.includes("referenceId") &&
                                    key !== "address" &&
                                    // exclude 12 nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes("nominatorDateOfExpiry") &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail') &&
                                    // ignore second poa field
                                    !key.includes('POAAuthorizePersonTwoName') &&
                                    !key.includes('POAAuthorizePersonTwoEmail') &&
                                    !key.includes('POAAuthorizedPersonType') &&
                                    !key.includes('hasSecondPOA')
                                );
                            }
                            // has not poa
                            if(! this.requiredPOA) {
                                if(shareholder.isNewNominator) 
                                    return (
                                        !!shareholder[key] &&
                                        !key.includes("secondaryCorporateRepresentative") &&
                                        !key.includes("nominatorDateOfExpiry") &&
                                        !key.includes( "idType") &&
                                        !key.includes("dateOfExpiry") &&
                                        
                                        // sow and sof field
                                        !key.includes("generateDueDiligence") &&
                                        !key.includes("sourcesOfFunds") &&
                                        !key.includes("otherSource") &&
                                        !key.includes("sourceOfWealth") &&
                                        !key.includes("otherWealth") &&

                                        !key.includes("referenceId") &&
                                        key !== "address" &&
                                        !key.includes("POA") &&
                                        // exclude 10 nominee shareholder fields
                                        !key.includes('isNomineeShareholder') &&
                                        !key.includes('isNewNominator') &&
                                        !key.includes('nominatorName') &&
                                        !key.includes('nominatorAlias') &&
                                        !key.includes('cessationDate') &&
                                        !key.includes('remark') &&
                                        // exclude new nominator fields
                                        ! key.includes('nominatorDOB') &&
                                        ! key.includes('nominatorIdType') &&
                                        ! key.includes('nominatorNationality') &&
                                        ! key.includes('nominatorEmail')
                                    );
                                return (
                                    !!shareholder[key] &&
                                    !key.includes("secondaryCorporateRepresentative") &&
                                    !key.includes( "idType") &&
                                    !key.includes("dateOfExpiry") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    !key.includes("referenceId") &&
                                    key !== "address" &&
                                    !key.includes("POA") &&
                                    // exclude 12 nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes("nominatorDateOfExpiry") &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('remark') &&
                                    // exclude new nominator fields
                                    ! key.includes('nominatorNRIC') &&
                                    ! key.includes('nominatorDOB') &&
                                    ! key.includes('nominatorAddress') &&
                                    ! key.includes('nominatorIdType') &&
                                    ! key.includes('nominatorNationality') &&
                                    ! key.includes('newNominatorName') &&
                                    ! key.includes('nominatorEmail')
                                );
                            }
                        }

                        if(this.requiredPOA) {
                            return (
                                !!shareholder[key] &&
                                !key.includes("secondaryCorporateRepresentative") &&
                                !key.includes( "idType") &&
                                !key.includes("dateOfExpiry") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("referenceId") &&
                                key !== "address" &&
                                // exclude corporate nominator fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes("nominatorDateOfExpiry") &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail') &&
                                // ignore second poa field
                                !key.includes('POAAuthorizePersonTwoName') &&
                                !key.includes('POAAuthorizePersonTwoEmail') &&
                                !key.includes('POAAuthorizedPersonType') &&
                                !key.includes('hasSecondPOA')
                            );
                        }

                        if(! this.requiredPOA) {
                            return (
                                !!shareholder[key] &&
                                !key.includes("secondaryCorporateRepresentative") &&
                                !key.includes( "idType") &&
                                !key.includes("dateOfExpiry") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("referenceId") &&
                                key !== "address" &&
                                !key.includes('POA') &&
                                // exclude corporate nominator fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes("nominatorDateOfExpiry") &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorType') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('appointmentDate') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorNRIC') &&
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorAddress') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorName') &&
                                ! key.includes('newNominatorName') &&
                                ! key.includes('nominatorEmail')
                            );
                        }
                    }

                    // NOMINEE SHAREHOLDER AND SHAREHOLDER TYPE INDIVIDUAL
                    if(shareholder.isNomineeShareholder) {
                        // nominator type individual case
                        if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                            if(shareholder.isNewNominator)
                                return (
                                    !!shareholder[key] &&
                                    !key.includes("CorporateRepresentative") &&
                                    !key.includes("POA") &&
                                    !key.includes("referenceId") &&
                                    
                                    // sow and sof field
                                    !key.includes("generateDueDiligence") &&
                                    !key.includes("sourcesOfFunds") &&
                                    !key.includes("otherSource") &&
                                    !key.includes("sourceOfWealth") &&
                                    !key.includes("otherWealth") &&

                                    !key.includes("dateOfExpiry") &&
                                    // exclude 12 nominee shareholder fields
                                    !key.includes('isNomineeShareholder') &&
                                    !key.includes("nominatorDateOfExpiry") &&
                                    !key.includes('isNewNominator') &&
                                    !key.includes('cessationDate') &&
                                    !key.includes('nominatorUen') &&
                                    !key.includes('nominatorLegalForm') &&
                                    !key.includes('nominatorStatue') &&
                                    !key.includes('nominatorRegistrar') &&
                                    !key.includes('nominatorJurisdiction') &&
                                    !key.includes('nominatorAlias') &&
                                    !key.includes('remark') &&
                                    // ignore new nominator field
                                    !key.includes('nominatorEmail') &&
                                    !key.includes('nominatorName')
                                );
                            return (
                                !!shareholder[key] &&
                                !key.includes("CorporateRepresentative") &&
                                !key.includes("POA") &&
                                !key.includes("referenceId") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("dateOfExpiry") &&
                                // exclude 17 nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes("nominatorDateOfExpiry") &&
                                !key.includes('isNewNominator') &&
                                !key.includes('cessationDate') &&
                                !key.includes('nominatorUen') &&
                                !key.includes('nominatorLegalForm') &&
                                !key.includes('nominatorStatue') &&
                                !key.includes('nominatorRegistrar') &&
                                !key.includes('nominatorJurisdiction') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('remark') &&
                                // ignore new nominator field
                                !key.includes('nominatorEmail') &&
                                !key.includes('newNominatorName') &&
                                !key.includes('nominatorIdType') &&
                                !key.includes('nominatorNationality') &&
                                !key.includes('nominatorDOB') &&
                                !key.includes('nominatorNRIC') &&
                                !key.includes('nominatorAddress')
                            );
                        }

                        if(shareholder.isNewNominator)
                            return (
                                !!shareholder[key] &&
                                !key.includes("CorporateRepresentative") &&
                                !key.includes("POA") &&
                                !key.includes("referenceId") &&
                                
                                // sow and sof field
                                !key.includes("generateDueDiligence") &&
                                !key.includes("sourcesOfFunds") &&
                                !key.includes("otherSource") &&
                                !key.includes("sourceOfWealth") &&
                                !key.includes("otherWealth") &&

                                !key.includes("dateOfExpiry") &&
                                // exclude 10 nominee shareholder fields
                                !key.includes('isNomineeShareholder') &&
                                !key.includes("nominatorDateOfExpiry") &&
                                !key.includes('isNewNominator') &&
                                !key.includes('nominatorAlias') &&
                                !key.includes('cessationDate') &&
                                !key.includes('remark') &&
                                // exclude new nominator fields
                                ! key.includes('nominatorDOB') &&
                                ! key.includes('nominatorIdType') &&
                                ! key.includes('nominatorNationality') &&
                                ! key.includes('nominatorEmail') && 
                                ! key.includes('nominatorName') 
                            );
                        return (
                            !!shareholder[key] &&
                            !key.includes("CorporateRepresentative") &&
                            !key.includes("POA") &&
                            !key.includes("referenceId") &&
                            
                            // sow and sof field
                            !key.includes("generateDueDiligence") &&
                            !key.includes("sourcesOfFunds") &&
                            !key.includes("otherSource") &&
                            !key.includes("sourceOfWealth") &&
                            !key.includes("otherWealth") &&

                            !key.includes("dateOfExpiry") &&
                            // exclude 12 nominee shareholder fields
                            !key.includes('isNomineeShareholder') &&
                            !key.includes("nominatorDateOfExpiry") &&
                            !key.includes('isNewNominator') &&
                            !key.includes('nominatorAlias') &&
                            !key.includes('cessationDate') &&
                            !key.includes('remark') &&
                            // exclude new nominator fields
                            ! key.includes('nominatorNRIC') &&
                            ! key.includes('nominatorDOB') &&
                            ! key.includes('nominatorAddress') &&
                            ! key.includes('nominatorIdType') &&
                            ! key.includes('nominatorNationality') &&
                            ! key.includes('newNominatorName') &&
                            ! key.includes('nominatorEmail')
                        );
                    }

                    // NOT NOMINEE SHAREHOLDER AND SHAREHOLDER TYPE INDIVIDUAL
                    return (
                        !!shareholder[key] &&
                        !key.includes("CorporateRepresentative") &&
                        !key.includes("POA") &&
                        !key.includes("referenceId") &&
                        
                        // sow and sof field
                        !key.includes("generateDueDiligence") &&
                        !key.includes("sourcesOfFunds") &&
                        !key.includes("otherSource") &&
                        !key.includes("sourceOfWealth") &&
                        !key.includes("otherWealth") &&
                        
                        !key.includes("dateOfExpiry") &&
                        // exclude 20 nominee shareholder fields
                        !key.includes('isNomineeShareholder') &&
                        !key.includes("nominatorDateOfExpiry") &&
                        !key.includes('isNewNominator') &&
                        !key.includes('nominatorType') &&
                        !key.includes('nominatorUen') &&
                        !key.includes('nominatorLegalForm') &&
                        !key.includes('nominatorStatue') &&
                        !key.includes('nominatorRegistrar') &&
                        !key.includes('nominatorJurisdiction') &&
                        !key.includes('nominatorAlias') &&
                        !key.includes('appointmentDate') &&
                        !key.includes('cessationDate') &&
                        !key.includes('remark') &&
                        !key.includes("dateOfExpiry") &&
                        // exclude new nominator fields
                        ! key.includes('nominatorNRIC') &&
                        ! key.includes('nominatorDOB') &&
                        ! key.includes('nominatorAddress') &&
                        ! key.includes('nominatorIdType') &&
                        ! key.includes('nominatorNationality') &&
                        ! key.includes('nominatorName') &&
                        ! key.includes('newNominatorName') &&
                        ! key.includes('nominatorEmail')
                    );
                }).length - 1 === this.perfectShareholderLength(shareholder)
            ).length;
            
            return (
                validShareholderCount === shareholders.length
            );
        },

        perfectShareholderLength(shareholder) {
            if (shareholder.shareholderType.text === SHAREHOLDER.TYPE.CORPORATE)
            {
                if (! this.hasNomineeDirector && ! this.requiredPOA)
                {   
                    /*
                       IGNORE_FIELD_1
                       --------------
                        // _id, secondaryCorporateRepresentativeName, secondaryCorporateRepresentativeAddress, address - 4
                        // poa person one (name, email), poa person two(name, email), POAAuthorizedPersonType, hasSecondPOA - 6
                        // nationality or country, idType, reference_id - 3
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
                    */

                    // SHAREHOLDER TYPE CORPORATE AND HAS NOMINEE DIRECTOR
                    if(shareholder.isNomineeShareholder) {
                        if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                            // IGNORE_FIELD_1
                            // ignore corporate and 12 nominee shareholder fields
                            // (isNomineeShareholder, isNewNominator, nominatorName, nominatorAlias, nominatorEmail, cessationDate, 
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            if(shareholder.isNewNominator)
                                return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 2 + 5 + 12);
                            
                            // IGNORE_FIELD_1
                            // ignore corporate and 17 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                            //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                            //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                            // nominatorAddress)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 2 + 5 + 17);
                        }

                        // CORPORATE NOMINATOR TYPE
                        // IGNORE_FIELD_1
                        // ignore corporate and 10 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                        // nominatorDOB, nominatorIdType, NominatorNationality, remark,) 
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        if(shareholder.isNewNominator)
                            return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 2 + 5 + 10);

                        // IGNORE_FIELD_1
                        // ignore corporate and 12 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress) 
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 2 + 5 + 12);
                    }

                    // IGNORE_FIELD_1
                    // ignore 20 nominee shareholder fields
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    return Object.keys(this.shareholderBluePrint).length - (4 + 6 + 3 + 2 + 5 + 20);
                }                

                /* 
                    IGNORE_FIELDS_2
                    ---------------
                    // _id, secondaryCorpRepName, secondaryCorpRepAdd, address for corporate type cases - 4
                    // nationality or country, idType, reference_id - 3
                    // ignore dateOfExpiry and nominator dateOfExpiry - 2
                    // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
                */
                
                if(shareholder.isNomineeShareholder) {
                    if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) { 
                        // has poa
                        if(this.requiredPOA) {
                            // IGNORE_FIELDS_2
                            // Ignore Corporate Fields and 12 nominee shareholder fields
                            // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail,   
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            // IGNORE SECOND POA FIELDS + 4
                            if(shareholder.isNewNominator) 
                                return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 2 + 5 + 12 + 4);
                            
                            // IGNORE_FIELDS_2
                            // ignore Corporate Fields, 17 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                            //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                            //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                            // nominatorAddress)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            // IGNORE SECOND POA FIELDS + 4
                            return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 2 + 5 + 17 + 4);
                        }
                        // has not poa
                        if(! this.requiredPOA) {
                            // Ignore 6 POA fields
                            // IGNORE_FIELDS_2
                            // Ignore Corporate Fields and 12 nominee shareholder fields
                            // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail,   
                            // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            if(shareholder.isNewNominator) 
                                return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 2 + 5 + 12);
                            
                            // Ignore  6 POA fields
                            // IGNORE_FIELDS_2
                            // ignore Corporate Fields, 17 nominee shareholder fields
                            // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                            //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                            //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                            // nominatorAddress)
                            // ignore dateOfExpiry and nominator dateOfExpiry
                            return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 2 + 5 + 17);
                        }  
                    }

                    // IGNORE_FIELDS_2
                    // IGNORE SECOND POA FIELDS + 4
                    // ignore Corporate Fields, 10 nominee shareholder fields
                    // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                    // nominatorDOB, nominatorIdType, NominatorNationality, remark,)
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    if(this.requiredPOA) {
                        if(shareholder.isNewNominator) 
                            return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 2 + 5 + 4 + 10);
                        
                        // IGNORE_FIELDS_2
                        // ignore Corporate Fields, 12 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress)
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        // IGNORE SECOND POA FIELDS + 4
                        return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 2 + 5 + 4 + 12);
                    }
                    // has not poa
                    if(! this.requiredPOA) {
                        // poa fields 6
                        // IGNORE_FIELDS_2
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        if(shareholder.isNewNominator) 
                            return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 2 + 5 + 10);

                        // poa fields 6
                        // IGNORE_FIELDS_2
                        // ignore Corporate Fields, 12 nominee shareholder fields
                        // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                        // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress)
                        // ignore dateOfExpiry and nominator dateOfExpiry
                        return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 2 + 5 + 12);
                    }
                    
                }
                
                if(this.requiredPOA)
                    // IGNORE_FIELDS_2
                    // IGNORE SECOND POA FIELDS + 4
                    // ignore Corporate Fields, 20 all nominee shareholder fields
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    return Object.keys(this.shareholderBluePrint).length - (4 + 3 + 2 + 4 + 5 + 20);
                // remove poa fields 6
                // IGNORE_FIELDS_2
                return Object.keys(this.shareholderBluePrint).length - (6 + 4 + 3 + 2 + 5 + 20);
            }

            /* 
                IGNORE_FIELD_3
                --------------
                // _id, primaryCorpRepName, primaryCorpRepAddress, secondaryCorpRepName, secondaryCorpRepAddress - 5
                // poa person one(name, email),poa person two(name, email), POAAuthorizedPersonType, hasSecondPOA - 6
                // nationality or country, reference_id - 2
                // ignore sourceOfFunds, sourceOfWealths, otherSource, otherWealth, generateDuediligence - 5
            */

            if(shareholder.isNomineeShareholder) {
                // INDIVIDUAL NOMINATOR TYPE
                if(shareholder.nominatorType.text === SHAREHOLDER.TYPE.INDIVIDUAL) {
                    // IGNORE_FIELD_3
                    // ignore corporate and 12 nominee shareholder fields
                    // (isNomineeShareholder, isNewNominator, nominatorName, nominatorAlias, nominatorEmail, cessationDate, 
                    // nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar, remark,)
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    if(shareholder.isNewNominator)
                        return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 5 + 12 + 2);

                    // IGNORE_FIELD_3
                    // ignore corporate and 17 nominee shareholder fields
                    // ( isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorEmail, 
                    //  nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, nominatorAlias, remark
                    //  nominatorUen, nominatorStatue, nominatorLegalForm, nominatorJurisdiction, nominatorRegistrar 
                    // nominatorAddress)
                    // ignore dateOfExpiry and nominator dateOfExpiry
                    return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 5 + 17 + 2);
                }
                // CORPORATE NOMINATOR TYPE
                // IGNORE_FIELD_3
                // ignore corporate and 10 nominee shareholder fields
                // (isNomineeShareholder, isNewNominator, cessationDate, nominatorName, nominatorAlias, nominatorEmail, 
                // nominatorDOB, nominatorIdType, NominatorNationality, remark,) 
                // ignore dateOfExpiry and nominator dateOfExpiry
                if(shareholder.isNewNominator)
                    return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 5 + 10 + 2);

                // IGNORE_FIELD_3
                // ignore corporate and 12 nominee shareholder fields
                // (isNomineeShareholder, isNewNominator, cessationDate, newNominatorName, nominatorAlias, nominatorEmail,  
                // nominatorDOB, nominatorIdType, NominatorNationality, nominatorNRIC, remark, nominatorAddress) 
                // ignore dateOfExpiry and nominator dateOfExpiry
                return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 5 + 12 + 2);
            }

            // IGNORE_FIELD_3
            // ignore corporate and 20 nominee shareholder fields
            // ignore dateOfExpiry and nominator dateOfExpiry
            return Object.keys(this.shareholderBluePrint).length - (5 + 6 + 2 + 5 + 20 + 2);
        },
    },
};
</script>

<style>
.formations.shareholders .card-body {
    padding: 1.3rem;
}
</style>
